import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation createWorkflow($projectId: String!, $input: CreateWorkflowInput!) {
    createWorkflow(projectId: $projectId, input: $input) {
      ...WorkflowFields
    }
  }
`
